export default __webpack_public_path__ + "static/logo-e08fb7315bcc73b8f64ca4db2f018a18.png";